module.exports = __webpack_public_path__ + "img/DE.a1435756.svg";